import { ENDPOINTS } from '../../apis/endpoints';
import { apiSlice } from '../../app/api/apiSlice';

export const EventApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllEvents: builder.query({
      query: () => ENDPOINTS.EVENTS.GET_ALL_EVENTS,
      providesTags: (result, error, id) =>
        result.data
          ? [{ type: 'Events', id: 'LIST' }, ...result.data.map(({ _id }) => ({ type: 'Events', id: _id }))]
          : [{ type: 'Events', id: 'LIST' }],
    }),
    getEventById: builder.query({
      query: (id) => `${ENDPOINTS.EVENTS.GET_EVENT_BY_ID}${id}`,
      providesTags: (result, error, id) => [{ type: 'Events', id }],
    }),
    postEvent: builder.mutation({
      query: (data) => ({
        url: ENDPOINTS.EVENTS.POST_EVENT,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'Events', id: 'LIST' }],
    }),
    updateEvent: builder.mutation({
      query: ({ id, formData }) => ({
        url: `${ENDPOINTS.EVENTS.UPDATE_EVENT}${id}`,
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Events', id }],
    }),
    deleteEvent: builder.mutation({
      query: (id) => ({
        url: `${ENDPOINTS.EVENTS.DELETE_EVENT}${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Events', id }],
    }),
  }),
});

export const {
  useGetAllEventsQuery,
  useGetEventByIdQuery,
  usePostEventMutation,
  useUpdateEventMutation,
  useDeleteEventMutation,
} = EventApiSlice;